/**
 * Retry RPC calls with exponential backoff
 */
export async function retryRPC<T>(
  fn: () => Promise<{ data: T; error: any }>,
  maxRetries = 3,
  delay = 1000
): Promise<{ data: T; error: any }> {
  for (let i = 0; i < maxRetries; i++) {
    const result = await fn();
    if (!result.error) return result;
    
    console.warn(`Retry ${i + 1}/${maxRetries} after error:`, result.error);
    await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
  }
  
  return fn(); // Final attempt
}
